import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import configApi from '../../config';

const BusiestDay = () => {
    const [busiestDay, setBusiestDay] = useState("Načítavam");
    const [isLoading, setIsLoading] = useState(true);

    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/DashboardContext`, config)
            .then(response => {
                setBusiestDay(response.data.busiestDayOfWeek || response.data.BusiestDayOfWeek || "N/A");
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching busiest day:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card w-100 h-100">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100 h-100">
            <div className="metric-icon" style={{ backgroundColor: '#f3e5f5', color: '#8e24aa' }}>
                <i className="bi bi-calendar-heart"></i>
            </div>
            <div className="metric-data">
                <h3 className="fw-bold m-0 text-dark" style={{ fontSize: '1.25rem' }}>
                    {busiestDay}
                </h3>
                <span
                    className="text-muted"
                    style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
                    data-tooltip-id="busiest-day-tooltip"
                    data-tooltip-content="Dátum, počas ktorého bolo historicky zrealizovaných absolútne najviac termínov."
                >
                    Najvyťaženejší deň
                </span>
            </div>
            <Tooltip id="busiest-day-tooltip" place="top" effect="solid" className="custom-tooltip" />
        </div>
    );
};

export default BusiestDay;
